import styled from '@emotion/styled';

import Icon from '@/assets/icons/icon_info_warning.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    textAlign: 'center',
  }),
);

export const Title = styled.p(() =>
  mq({
    fontWeight: 'bold',
    fontSize: defaultTheme.font.size.m,
    marginTop: '60px',
  }),
);

export const InfoWarningIcon = styled.i(() =>
  mq({
    position: 'absolute',
    width: '40px',
    height: '40px',
    top: '24px',
    left: '0',
    right: '0',
    margin: '0 auto',
    backgroundImage: `url(${Icon})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }),
);

export const Description = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    marginTop: defaultTheme.spacing.l,
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    width: ['295px', '295px', '320px', '320px'],
    margin: `${defaultTheme.spacing.xxl} auto 0 auto`,
  }),
);
